import { createContext, useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";

import { useGetCurrentUser } from "../api/user";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  const { data, isSuccess, isError } = useGetCurrentUser();

  // Set user in Sentry, so we can see it in the Sentry dashboard
  // And we can easily debug issues with user specific data
  const handleSetUser = (user) => {
    setUser(user);

    if (user) {
      Sentry.setUser({
        id: user?.id,
        email: user?.email,
      });

      posthog.identify(user.email, {
        user_id: user.id,
      });
    } else {
      Sentry.setUser(null);
      // reset() wipes super properties, so carry the environment tag across it.
      const environment = posthog.get_property("environment");
      posthog.reset();
      posthog.register({ environment });
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      handleSetUser(null);
      setLoading(false);
      return;
    }

    if (isSuccess) {
      handleSetUser(data);
      setLoading(false);
    }
    if (isError) {
      handleSetUser(null);
      setLoading(false);
    }
  }, [data, isSuccess, isError]);

  return (
    <AuthContext.Provider value={{ user, setUser: handleSetUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
